import { SxProps, Theme } from '@mui/material';

export const colorOverflowButtonSX: SxProps<Theme> = {
	width: '33px',
	height: '33px',
	borderRadius: '50%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

export const colorOverflowCircleSX: SxProps<Theme> = {
	width: '27px',
	height: '27px',
	borderRadius: '50%',
	border: '1px solid #E0E0E0',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: '#F5F5F5',
};

export const colorOverflowTextSX: SxProps<Theme> = {
	fontSize: '12px',
	fontWeight: '600',
	color: '#2C2C2C',
	'&:hover': { textDecoration: 'underline' },
};
